import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import ParkingLander from './ParkingLander';
import { IntlProvider } from 'react-intl';
import { getLocaleFromCookie, getLocalizedMessages } from './i18n/locale.js';

const locale = getLocaleFromCookie();
const useMessages = getLocalizedMessages(locale);
ReactDOM.render(
  <IntlProvider locale={ locale } messages={ useMessages }>
    <ParkingLander/>
  </IntlProvider>,
  document.getElementById('contentMain')
);
